import { render, staticRenderFns } from "./BrowseBuildingChukan.vue?vue&type=template&id=106b04ea&scoped=true&"
import script from "./BrowseBuildingChukan.vue?vue&type=script&lang=js&"
export * from "./BrowseBuildingChukan.vue?vue&type=script&lang=js&"
import style0 from "./BrowseBuildingChukan.vue?vue&type=style&index=0&id=106b04ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106b04ea",
  null
  
)

export default component.exports